export const GoogleMapsAPI = 'AIzaSyAI9qtH7xxemsrHm0PBNSjwjpzowfIDRtI';
// export const GoogleMapsAPI = 'AIzaSyBi_csH14w6gt6h7YvGrrQ7g4DGXgeNiUI';
